function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#F64B39",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 51,
  cy: 42,
  rx: 13,
  ry: 20,
  transform: "rotate(-12 51 42)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 89,
  cy: 38,
  rx: 13,
  ry: 20,
  transform: "rotate(9 89 38)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 25,
  cy: 75,
  rx: 12,
  ry: 18,
  transform: "rotate(-28 25 75)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 129,
  cy: 72,
  rx: 12,
  ry: 18,
  transform: "rotate(27 129 72)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80 67C66 67 58 79 51 90C45 100 35 107 35 119C35 131 45 139 56 139C65 139 71 134 80 134C89 134 96 139 105 139C116 139 125 131 125 119C125 107 116 100 109 90C102 79 94 67 80 67Z"
}));

function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0421\u043B\u0435\u0434 \u043B\u0430\u043F\u044B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.e44e28179eed0ded70671bd39f71e6de.svg";
export { ForwardRef as ReactComponent };